import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlgorithmComponent } from './components/algorithm/algorithm.component';
import { PpoParametersComponent } from './components/ppo-parameters/ppo-parameters.component';
import { AlgorithmFormService } from './services/algorithm-form.service';
import { AdamParametersComponent } from './components/adam-parameters/adam-parameters.component';
import { SacParametersComponent } from './components/sac-parameters/sac-parameters.component';
import { ExpertDatasetComponent } from './components/expert-dataset/expert-dataset.component';
import { BcParametersComponent } from './components/bc-parameters/bc-parameters.component';
import { AdversarialTrainerParametersComponent } from './components/adversarial-trainer-parameters/adversarial-trainer-parameters.component';
import { SkillArchitectureModule } from '../skill-architecture/skill-architecture.module';

@NgModule({
    imports: [
        NgbModule,
        CommonModule,
        SharedModule,
        MaterialModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
        SkillArchitectureModule,
    ],
    declarations: [
        AlgorithmComponent,
        PpoParametersComponent,
        AdamParametersComponent,
        SacParametersComponent,
        ExpertDatasetComponent,
        BcParametersComponent,
        AdversarialTrainerParametersComponent,
    ],
    providers: [AlgorithmFormService],
    exports: [AlgorithmComponent],
})
export class AlgorithmModule {}
